import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { UserService, ScrollParams, ScrollService } from '../../api';
import * as _ from 'lodash';
import 'intl';
import 'intl/locale-data/jsonp/en';

@Component({
  selector: 'followers-of-user',
  templateUrl: './followers-of-user.component.html',
  styleUrls: ['./followers-of-user.component.css']
})
export class FollowersOfUserComponent implements OnInit, OnDestroy {
  @Input() followers: Array<any> = new Array<any>();
  private loading: boolean = true;
  private scrollParams = new ScrollParams();
  private scrollSubscriber = null;
  public onlineOffline: boolean = navigator.onLine;
  enableScrollForFollowers = true;

  constructor(private userService: UserService, private scrollService: ScrollService) {
    window.addEventListener('online', () => {this.onlineOffline = true;});
    window.addEventListener('offline', () => {this.onlineOffline = false;});
  }

  ngOnInit() {
    this.getActivityData();
    this.scrollSubscriber = this.scrollService.onScroll.subscribe((event) => this.getActivityData());
  }

  getActivityData() {
    if(this.enableScrollForFollowers) {
      if (this.scrollParams.recordsFinished) {
        return;
      }
      this.loading = true;
      if(this.onlineOffline) {
        this.userService.loadUserFollowers(this.scrollParams).subscribe((res) => {
          if (res.length > 0) {
            res.forEach((arrayItem) => {
              this.followers.push(arrayItem);
            });
            this.scrollParams.page++;
          } else {
            this.scrollParams.recordsFinished = true;
          }
          if(res.length == 0 || res.length < 20) {
            this.enableScrollForFollowers = false;
          }
          this.followers = _.uniqBy(this.followers, 'id');
          this.loading = false;
        },
        (error) => {
          console.log(error);
        });
      } else {
        this.loading = false;
      }
    }
  }

  ngOnDestroy() {
    if (this.scrollSubscriber != null) {
      this.scrollSubscriber.unsubscribe();
    }
  }
  
}



// WEBPACK FOOTER //
// ./src/app/dashboard/followers-of-user/followers-of-user.component.ts